import DesignTokens from '@tableau/design-tokens';
import { Recurrence, TimeZoneDetails } from '@tableau/self-service-schedules';
import { TabStyles, TextLinkKind, TextLinkWidget } from '@tableau/widgets';
import React from 'react';

import { IScheduleInfo } from '~src/schedule/types/IScheduleInfo';
import { cssClass } from '~src/style';
import { applyColor }from '~src/style/ColorService';

import { Messages } from '../../codegen/Localize';

const cssPrefix = 'FlowTaskSelfServiceSchedulePickerBanner';

const dialogTitle = cssClass(cssPrefix, 'dialogHeader', {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  minHeight: TabStyles.Sizing.BaseUnit * 5,
});

const titleContent = cssClass(cssPrefix, 'titleContent', {
  color: applyColor(DesignTokens.color.font.default.default, TabStyles.Typography.Color.Primary),
  margin: `0 ${TabStyles.Spacing.LargeSpace}px`,
});

const solidBackgroundStyle = { backgroundColor: applyColor(DesignTokens.color.elevation.surface.default.subtle, TabStyles.Colors.F2) };
const borderStyle = { borderBottom: `1px solid ${applyColor(DesignTokens.color.elevation.border.default.subtle, TabStyles.Colors.F5)}`};

export interface FlowTaskSelfServiceSchedulePickerBannerProps {
  timeZoneDetails: TimeZoneDetails;
  recurrence: Recurrence;
  solidBackground: boolean;
}

export function FlowTaskSelfServiceSchedulePickerBanner(props: FlowTaskSelfServiceSchedulePickerBannerProps) {
  return (
    <div className={dialogTitle} style={props.solidBackground ? solidBackgroundStyle : borderStyle }>
      <div className={titleContent}>
        {Messages.frequency()}: {IScheduleInfo.getRecurrenceDescription(props.recurrence)}
      </div>
      <div className={titleContent}>
        {`${Messages.timeZone()}: `}
        {props.timeZoneDetails &&
          <TextLinkWidget
            href={props.timeZoneDetails.linkToUserSettings}
            kind={TextLinkKind.Standard}
            testId={`${cssPrefix}-timeZone`}
          >
            {props.timeZoneDetails.timeZoneDisplayName}
          </TextLinkWidget>
        }
      </div>
    </div>
  );
}